import { createSlice } from "@reduxjs/toolkit";

const initialUserPermissionState = {
  error: null,
  listLoading: false,
  userPermissions: [],
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const userPermissionsSlice = createSlice({
  name: "userPermissions",
  initialState: initialUserPermissionState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    userPermissionsFetched: (state, action) => {
      const { data } = action.payload;
      state.error = null;
      state.listLoading = false;
      state.userPermissions = data;
    },
  },
});
